import { FC } from 'react'

import { Switch, SwitchProps } from '@mantine/core'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants.ts'

const StyledSwitch = styled(Switch)`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${colors.secondGray};
  background-color: white;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &:has(input:checked) {
    border-color: ${colors.fourthBlue};
    background-color: #eef4ff;
  }

  .mantine-Switch-label {
    color: ${colors.thirdBlue};
    font-weight: 600;
    white-space: nowrap;
  }

  .mantine-Switch-body {
    align-items: center;
  }
`

export const ToggleSwitch: FC<SwitchProps> = (props) => (
  <StyledSwitch color={colors.fourthBlue} size='md' {...props} />
)
